var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "informacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3226",
    "data-name": "Group 3226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3225",
    "data-name": "Group 3225"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 0.854,
    cy: 0.854,
    r: 0.854,
    transform: "translate(7.896 12.083)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3531",
    "data-name": "Path 3531",
    d: "M8.75,0A8.75,8.75,0,1,0,17.5,8.75,8.745,8.745,0,0,0,8.75,0Zm0,16.133A7.383,7.383,0,1,1,16.133,8.75,7.379,7.379,0,0,1,8.75,16.133Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3532",
    "data-name": "Path 3532",
    d: "M178.734,128.5A2.738,2.738,0,0,0,176,131.234a.684.684,0,0,0,1.367,0,1.367,1.367,0,1,1,1.367,1.367.684.684,0,0,0-.684.684v1.709a.684.684,0,0,0,1.367,0v-1.112a2.735,2.735,0,0,0-.684-5.382Z",
    transform: "translate(-169.984 -124.108)",
    fill: "#989898"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformacion);
export default __webpack_public_path__ + "static/media/informacion.4f396c63b78ee1e6a1765fffb16776d1.svg";
export { ForwardRef as ReactComponent };